import { Component, OnInit} from '@angular/core';
import { MatFormFieldModule, MatLabel } from "@angular/material/form-field";
import { FormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { ReviewService } from "../../services/review.service";
import { CreateReviewModel } from "../../models/review";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { StarRatingComponent } from "../star-rating/star-rating.component";
import { AsyncPipe, NgIf } from "@angular/common";
import { Observable } from 'rxjs';
import { ViewRideBookingModel } from 'src/app/models/booking';
import { RideBookingStatus } from 'src/app/models/enums';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-create-review',
    imports: [
        MatLabel,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        StarRatingComponent,
        NgIf,
        AsyncPipe,
        MatProgressSpinner,
        RouterLink
    ],
    templateUrl: './create-review.component.html'
})

export class CreateReviewComponent implements OnInit {
  rideBookingId: string;
  reviewedUserId: string;
  reviewText: string = '';
  rating: number = 0;
  starCount: number = 5;
  reviewExists$: Observable<boolean>;
  currentUserId!: string ;
  booking!: ViewRideBookingModel;

  public RideBookingStatus = RideBookingStatus;

  private readonly okMessage = $localize`OK`;
  private readonly errorMessage = $localize`Sorry, an error has happened`;

  constructor(private activateRoute: ActivatedRoute,
    private router: Router,
    private toastrService: ToastrService,
    private reviewService: ReviewService,
    private authService: AuthService) {

    this.rideBookingId = this.activateRoute.snapshot.paramMap.get('rbId')!;
    this.reviewedUserId = this.activateRoute.snapshot.paramMap.get('pId')!;

    this.reviewExists$ = this.reviewService.reviewExists(this.rideBookingId);
  }

  ngOnInit() {
    this.booking = this.activateRoute.snapshot.data['booking'] as ViewRideBookingModel;
    this.currentUserId = this.authService.user$.value.user!.id!;
  }

  submitReview() {
    let model: CreateReviewModel = {
      rideBookingId: this.rideBookingId,
      rating: this.rating,
      comment: this.reviewText,
      reviewedPersonId: this.reviewedUserId
    };
    this.reviewService.addReview(model)
      .subscribe({
        next: _ => this.router.navigateByUrl(`person/${this.reviewedUserId}/reviews`),
        error: _ => this.toastrService.error(this.errorMessage)
      });
  }

  onRatingChanged(rating: number) {
    this.rating = rating;
  }
}
